import styled from 'styled-components';

const NavContainer = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;

  &.scrolled {
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
  }

  /* Hide navbar when sidebar is open on mobile */
  &.sidebar-open {
    @media (max-width: 991px) {
      transform: translateY(-100%);
      opacity: 0;
      pointer-events: none;
    }
  }

  .nav-center {
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  @media (min-width: 1024px) {
    .nav-center {
      padding: 0 2rem;
    }
  }

  /* Logo */
  .nav-logo {
    flex-shrink: 0;
    
    a {
      display: flex;
      align-items: center;
    }
    
    img {
      height: 60px;
      width: auto;
      max-width: 140px;
      object-fit: contain;
      border-radius: 8px;
    }
  }

  @media (min-width: 768px) {
    .nav-logo img {
      height: 70px;
      max-width: 170px;
    }
  }

  /* Navigation Links - Hidden on mobile */
  .nav-links {
    display: none;
  }

  @media (min-width: 1024px) {
    .nav-links {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      list-style: none;
      margin: 0;
      padding: 0;
      flex: 1;
    }
  }

  /* Navigation Groups */
  .nav-group {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  /* Main Navigation Group (Products, About, Orders) */
  .main-nav {
    background: linear-gradient(135deg, #17bfcf 0%, #0d9488 100%);
    border-radius: 2rem;
    padding: 0.25rem;
  }

  .main-link {
    color: white !important;
    font-weight: 600 !important;
    padding: 0.5rem 1rem !important;
    border-radius: 1.5rem;
    transition: all 0.3s ease !important;

    &:hover {
      background: rgba(255, 255, 255, 0.2) !important;
      color: white !important;
    }

    &.active {
      background: white !important;
      color: #0d9488 !important;
    }

    &::after {
      display: none !important;
    }
  }

  /* Separator between groups */
  .nav-separator {
    width: 1px;
    height: 24px;
    background: #e0e0e0;
    margin: 0 0.5rem;
  }

  /* Categories Group */
  .categories-nav {
    background: #f8f9fa;
    border-radius: 2rem;
    padding: 0.25rem;
  }

  .category-link {
    color: #555 !important;
    font-weight: 500 !important;
    padding: 0.5rem 0.875rem !important;
    border-radius: 1.5rem;
    font-size: 0.875rem !important;
    transition: all 0.3s ease !important;

    &:hover {
      background: #e9ecef !important;
      color: #111718 !important;
    }

    &::after {
      display: none !important;
    }
  }

  .nav-link {
    position: relative;
    display: inline-block;
    padding: 0.5rem 1rem;
    font-size: 0.9375rem;
    font-weight: 500;
    color: #4a4a4a;
    text-decoration: none;
    letter-spacing: 0.02em;
    transition: color 0.3s ease;
    white-space: nowrap;

    &:hover {
      color: #111718;
    }

    &.active {
      color: #111718;
      font-weight: 600;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background: #17bfcf;
      transition: width 0.3s ease;
    }

    &:hover::after,
    &.active::after {
      width: calc(100% - 2rem);
    }
  }

  @media (min-width: 1280px) {
    .nav-link {
      padding: 0.5rem 1.25rem;
      font-size: 1rem;
    }
  }

  /* Right Section Container */
  .nav-right {
    display: flex;
    align-items: center;
    gap: 0;
    flex-shrink: 0;
  }

  /* Right Icons Container */
  .nav-icons {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    flex-shrink: 0;
  }

  @media (min-width: 1024px) {
    .nav-icons {
      gap: 0.5rem;
    }
  }

  .icon-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: transparent;
    border: none;
    border-radius: 50%;
    color: #4a4a4a;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      color: #111718;
      background: #f5f5f5;
    }

    svg {
      font-size: 1rem;
    }
  }

  @media (min-width: 768px) {
    .icon-btn {
      width: 40px;
      height: 40px;
      
      svg {
        font-size: 1.125rem;
      }
    }
  }

  .search-btn {
    display: none;
  }

  @media (min-width: 1024px) {
    .search-btn {
      display: flex;
    }
  }

  /* Mobile Toggle */
  .nav-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: transparent;
    border: none;
    border-radius: 0.5rem;
    color: #111718;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-left: 0.25rem;

    &:hover {
      background: #f5f5f5;
    }

    svg {
      font-size: 1.25rem;
    }
  }

  @media (min-width: 1024px) {
    .nav-toggle {
      display: none;
    }
  }

  /* Search Overlay */
  .search-overlay {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    padding: 1.5rem;
    border-bottom: 1px solid #f0f0f0;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    animation: slideDown 0.3s ease;
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .search-container {
    max-width: 600px;
    margin: 0 auto;
    position: relative;

    input {
      width: 100%;
      height: 48px;
      padding: 0 3rem 0 1.25rem;
      font-size: 1rem;
      border: 1px solid #e0e0e0;
      border-radius: 0.5rem;
      background: #f9f9f9;
      color: #111718;
      transition: all 0.3s ease;

      &:focus {
        outline: none;
        border-color: #17bfcf;
        background: white;
        box-shadow: 0 0 0 3px rgba(23, 191, 207, 0.1);
      }

      &::placeholder {
        color: #9ca3af;
      }
    }

    .search-icon {
      position: absolute;
      right: 1rem;
      top: 50%;
      transform: translateY(-50%);
      color: #9ca3af;
      pointer-events: none;
    }
  }

  /* RTL Support */
  &[dir='rtl'] {
    .nav-links {
      direction: rtl;
    }

    .nav-link {
      font-family: 'Arial', 'Tahoma', sans-serif;
    }

    .search-container {
      input {
        padding: 0 1.25rem 0 3rem;
      }

      .search-icon {
        right: auto;
        left: 1rem;
      }
    }
  }

  /* Cart Button Wrapper Override for Navbar */
  .cart-btn-wrapper {
    display: flex !important;
    align-items: center;
    gap: 0.5rem;
    width: auto;
  }
`;

export default NavContainer;
